/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BusinessObjectFormatRetentionInformationUpdateRequest { 
    /**
     * Retention period (in days) for business object data registered with this format. This value must only be specified for                   PARTITION_VALUE retention type                
     */
    retentionPeriodInDays?: number;
    /**
     * Retention type. Supported retention types are: PARTITION_VALUE, BDATA_RETENTION_DATE                
     */
    retentionType?: string;
}
